// components/Сonfirmation/Сonfirmation.jsx
import "./Сonfirmation.css";
import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import HeaderLogin from "../CoursePage/HeaderLogin/HeaderLogin";
import Footer from "../Footer/Footer";
import { CurrentUserContext } from "../../contexts/CurrentUserContext";


function Сonfirmation({ exitLogin }) {
  const { currentUser } = useContext(CurrentUserContext);

  return (
    <>
      <Helmet>
        <title>Подтверждение регистрации — Школа КТМ</title>
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href="https://kt-mebel.ru/confirmation" />
      </Helmet>
      <HeaderLogin exitLogin={exitLogin} />

      <main className="confirmation">
        <div className="confirmation__card">
          <h1 className="confirmation__title">
            Здравствуйте{currentUser?.name ? `, ${currentUser.name}` : ""}!
          </h1>

          <p className="confirmation__lead">
            Добро пожаловать в&nbsp;онлайн-школу конструктора-технолога мебели.
            Для активации аккаунта перейдите по&nbsp;ссылке из письма, которое мы
            отправили на вашу почту.
          </p>

          {currentUser?.email && (
            <div className="confirmation__badge" aria-live="polite">
              <span className="confirmation__badge-label">Письмо отправлено на</span>
              <span className="confirmation__badge-email">{currentUser.email}</span>
            </div>
          )}

          <ul className="confirmation__tips" aria-label="Подсказки">
            <li>Проверьте папку «Спам» или «Промоакции».</li>
            <li>Если письма нет в течение 3–5 минут — обновите страницу почты.</li>
            <li>Нужна помощь? Напишите нам: <a href="mailto:ktm-online@mail.ru">ktm-online@mail.ru</a></li>
          </ul>

          <p className="confirmation__note">
            После активации вы получите полный доступ к&nbsp;материалам курса.
            Рады, что вы с нами!
          </p>
        </div>
      </main>

      <Footer />
      
    </>
  );
}

export default Сonfirmation;
